<template>
    <div>
        <b-card title="Enquiry Email Sending Logs">
            <b-form-group label="Filter by Status:" label-for="status-filter" class="mb-3">
                <b-form-select
                    id="status-filter"
                    v-model="statusFilter"
                    :options="statusOptions"
                    @change="onFilterChange"
                    :disabled="isLoading"
                    class="w-auto"
                />
            </b-form-group>

            <b-table
                striped
                hover
                :items="emailLogs"
                :fields="fields"
                responsive="sm"
                @row-clicked="goToEnquiry"
                :busy="isLoading"
            >
                <template #cell(status)="data">
                    <b-badge :variant="statusVariant(data.item.status)">
                        {{ data.item.status }}
                    </b-badge>
                </template>
                <template #cell(error_log)="data">
                    <span v-if="data.item.error_log">{{ data.item.error_log }}</span>
                    <span v-else class="text-muted">-</span>
                </template>
            </b-table>

            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                @change="fetchEmailLogs"
                class="mt-3"
            />
        </b-card>
    </div>
</template>

<script>
import {
    BCard, BTable, BBadge, BPagination, BFormSelect, BFormGroup,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
    components: {
        BCard, 
        BTable, 
        BBadge,
        BPagination,
        BFormSelect, 
        BFormGroup,
    },
    data() {
        return {
            emailLogs: [],
            fields: [
                { key: 'enquiry_id', label: 'Enquiry Id' },
                { key: 'status', label: 'Status' },
                { key: 'error_log', label: 'Error Log' },
                { key: 'formatted_created_at', label: 'Date/Time' }
            ],
            emailLogs: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            isLoading: false,
            statusFilter: '',
            statusOptions: [
                { value: '', text: 'All' },
                { value: 'success', text: 'Success' },
                { value: 'error', text: 'Error' },
                { value: 'pending', text: 'Pending' },
            ],
        }
    },
    methods: {
        statusVariant(status) {
            switch (status) {
                case 'success': return 'success';
                case 'error': return 'danger';
                case 'pending': return 'warning';
                default: return 'secondary';
            }
        },
        async fetchEmailLogs() {
            try {
                this.isLoading = true
                const offset = (this.currentPage - 1) * this.perPage

                const payload = {
                    perpage: this.perPage,
                    offset: offset,
                }

                if (this.statusFilter) {
                    payload.status = this.statusFilter
                }

                const response = await axios.post('enquiry/v1/email-logs', payload)

                this.emailLogs = response?.data?.data || []
                this.totalRows = response?.data?.total || 0
            } catch (error) {
                console.error('Error loading logs:', error)
            } finally {
                this.isLoading = false
            }
        },
        goToEnquiry(row) {
            this.$router.push({ name: 'enquiry-edit', params: { id: row.enquiry_id } });
        },
        onFilterChange() {
            this.currentPage = 1
            this.fetchEmailLogs()
        },
    },
    mounted() {
        this.fetchEmailLogs();
    }
}
</script>